module.exports = __webpack_public_path__ + "static/media/panificacion_cereal.e08b1910.png";